<template>
	<div>
		<h1>Dissemination</h1>

		<InputTextMultiLine
			question="What is the dissemination policy for the trial "
			placeholder="e.g. Research findings from the trial will be disseminated through journal submissions, oral and poster presentations, and conference abstracts. 

Plans for investigators to communicate trial results to participants, healthcare professionals, the public, media press release/s, and other relevant groups (e.g., thrpugh publication, reporting in results databases, or other data sharing arrangements), including any publication restrictions. Authorship eligibility guidelines, as well as any intended use of professional writers. Plans for granting public access to the full protocol via a not-for-profit online platform, where patients and their health providers can  collaborate on the food intervention. "
			v-model="$tera.project.TrialWizard.dissemination"
			bookmark="dissemination-policy"
		/>

		<!--New added-->
		<InputTextMultiLine
			question="Authorship eligibility guidelines and any intended use of professional writers"
			placeholder="e.g. the opinions expressed are those of the authors and not necessarily of the NIH or any other organization"
			v-model="$tera.project.TrialWizard.guidelines"
			bookmark="authorship-eligibility"
		/>

		<InputTextMultiLine
			question="Specify the plans, if any, for granting public access to the full protocol, participant-level dataset, and statistical code "
			placeholder="e.g. the full protocol, data and statistical code is available on request"
			v-model="$tera.project.TrialWizard.plans"
			bookmark="plans-publicaccess"
		/>

		<BasePreviewOutput :component="outputComponent" />
	</div>
</template>

<script>
import OutputDissemination from "./OutputDissemination.vue";
import InputTextMultiLine from "../../components/InputTextMultiLine.vue";

export default {
	components: { InputTextMultiLine },
	data() {
		return {
			outputComponent: OutputDissemination
		};
	}
};
</script>
